import { render } from "./WorldEnded.vue?vue&type=template&id=4ce20bec"
import script from "./WorldEnded.vue?vue&type=script&lang=js"
export * from "./WorldEnded.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/WorldEnded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ce20bec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ce20bec', __exports__)) {
    api.reload('4ce20bec', __exports__)
  }
  
  module.hot.accept("./WorldEnded.vue?vue&type=template&id=4ce20bec", () => {
    api.rerender('4ce20bec', render)
  })

}


export default __exports__